import Presenter from 'microcosm/addons/presenter'
import { getFactors, getFactorSeries } from '../../actions/factors'
import { within } from '../../selection'

class FactorsPresenter extends Presenter {
  setup(repo, { location }) {
    repo.push(getFactors).onDone(() => {
      this.fetch(repo, location.query)
    })
  }

  update(repo, { location }) {
    if (
      location.query.selected !== this.props.location.query.selected ||
      location.query.region !== this.props.location.query.region
    ) {
      this.fetch(repo, location.query)
    }
  }

  fetch(repo, { selected }) {
    const request = repo.prepare(getFactorSeries)
    const { factors } = repo.state

    let picked = factors
      .filter(s => s.Region === repo.state.ui.region.value)
      .filter(s => within(selected, s.Key))

    picked.forEach(s => request(s.ID))
  }
}

export default FactorsPresenter



// WEBPACK FOOTER //
// ./src/presenters/factors/index.js